import moment from 'moment'

const MAX_FIRST_NAME_LENGTH = 40
const MAX_LAST_NAME_LENGTH = 80
const MIN_DATE = '1900-01-01'

const emojiRegex = /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{1F900}-\u{1F9FF}]|[\u{1F018}-\u{1F270}]|[\u{238C}]|[\u{2194}-\u{2199}]|[\u{21A9}-\u{21AA}]|[\u{231A}-\u{231B}]|[\u{23E9}-\u{23EC}]|[\u{23F0}]|[\u{23F3}]|[\u{25FD}-\u{25FE}]|[\u{2614}-\u{2615}]|[\u{2648}-\u{2653}]|[\u{267F}]|[\u{2693}]|[\u{26A1}]|[\u{26AA}-\u{26AB}]|[\u{26BD}-\u{26BE}]|[\u{26C4}-\u{26C5}]|[\u{26CE}]|[\u{26D4}]|[\u{26EA}]|[\u{26F2}-\u{26F3}]|[\u{26F5}]|[\u{26FA}]|[\u{26FD}]|[\u{2705}]|[\u{270A}-\u{270B}]|[\u{2728}]|[\u{274C}]|[\u{274E}]|[\u{2753}-\u{2755}]|[\u{2757}]|[\u{2795}-\u{2797}]|[\u{27B0}]|[\u{27BF}]|[\u{2B1B}-\u{2B1C}]|[\u{2B50}]|[\u{2B55}]/gu

const afterMinimumDate = (date) => !!date && !!moment(date).isSameOrAfter(MIN_DATE)
const afterMinimumDateOrEmpty = (date) => !date || afterMinimumDate(date)

function isAtLeast16YearsOld(date) {
  if (!date || !moment(date, moment.ISO_8601, true).isValid()) return false
  const today = moment().startOf('day')
  const minimumBirthDate = today.clone().subtract(16, 'years')
  return moment(date).isSameOrBefore(minimumBirthDate, 'day')
}

const isAtLeast16YearsOldOrEmpty = (date) => !date || isAtLeast16YearsOld(date)

function containsEmoji(str) {
  return emojiRegex.test(str)
}

function removeEmojis(str) {
  return str.replace(emojiRegex, '')
}

function handleInput(e) {
  const value = e.target.value

  if (containsEmoji(value)) {
    const cleanValue = removeEmojis(value)
    e.target.value = cleanValue
  }
}

function handlePaste(e) {
  e.preventDefault()

  const pastedText = (e.clipboardData || (window.clipboardData ? window.clipboardData : null))?.getData('text') || ''
  const input = e.target
  const start = input.selectionStart
  const end = input.selectionEnd
  const currentValue = input.value

  if (containsEmoji(pastedText)) {
    const cleanText = removeEmojis(pastedText)
    input.value = currentValue.substring(0, start) + cleanText + currentValue.substring(end)
  } else {
    input.value = currentValue.substring(0, start) + pastedText + currentValue.substring(end)
  }
  input.dispatchEvent(new Event('input')) // Trigger input event to notify Vue of the change
}

function handleKeydown(e) {
  const key = e.key

  if (key && key.length === 2 && containsEmoji(key)) {
    e.preventDefault()
  }
}

function initEmojiBlocker(inputElement) {
  inputElement.addEventListener('input', handleInput)
  inputElement.addEventListener('paste', handlePaste)
  inputElement.addEventListener('keydown', handleKeydown)
}

export {
  MAX_FIRST_NAME_LENGTH,
  MAX_LAST_NAME_LENGTH,
  MIN_DATE,
  afterMinimumDate,
  afterMinimumDateOrEmpty,
  isAtLeast16YearsOld,
  isAtLeast16YearsOldOrEmpty,
  initEmojiBlocker
}
